import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import ThankYouNotQualifyCost from '@/features/v2/hh/components/thankYou/ThankYouNotQualifyCost';
import ThankYouNotQualifyFixCostEnough from '@/features/v2/hh/components/thankYou/ThankYouNotQualifyFixCostEnough';
import ThankYouNotQualifyIssuerDecision from '@/features/v2/hh/components/thankYou/ThankYouNotQualifyIssuerDecision';
import ThankYouNotQualifySettlement from '@/features/v2/hh/components/thankYou/ThankYouNotQualifySettlement';
import { HHSchemaDeadEndsStepOne } from '@/features/v2/hh/stepsSchema';
import {
  getUserType,
  notQualifiedDataLayer,
} from '@/helpers/addStageToDataLyer';

const NotQualify = () => {
  // This component uses data directly from the backend (which is ensured to be the same due to revalidation)
  // instead of using the 'watch' function. This is because this component is higher in the hierarchy than the form component.
  const { data } = useFormDataQuery();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formData = data?.payload?.data as Record<any, any>;

  const SETTLEMENT = HHSchemaDeadEndsStepOne.settlement.condition(formData);

  const COSTS = HHSchemaDeadEndsStepOne.fixCostDifference.condition(formData);

  const FIX_COST_ENOUGH =
    HHSchemaDeadEndsStepOne.fixCostEnough.condition(formData);

  const userType = getUserType(data);

  useEffect(() => {
    if (SETTLEMENT) {
      notQualifiedDataLayer('ugoda', 'not_qaulify', userType);
      return;
    }
    if (COSTS) {
      notQualifiedDataLayer('za_mała_kwota', 'not_qaulify', userType);
      return;
    }
    if (FIX_COST_ENOUGH) {
      notQualifiedDataLayer(
        'kwota_wystarczyła_na_naprawę',
        'not_qaulify',
        userType
      );
      return;
    }
    notQualifiedDataLayer(
      'negatywna_decyzja_ubezpieczyciela',
      'not_qaulify',
      userType
    );
  }, [COSTS, FIX_COST_ENOUGH, SETTLEMENT, data, userType]);

  if (SETTLEMENT) {
    return <ThankYouNotQualifySettlement />;
  }

  if (COSTS) {
    return <ThankYouNotQualifyCost />;
  }

  if (FIX_COST_ENOUGH) {
    return <ThankYouNotQualifyFixCostEnough />;
  }

  return <ThankYouNotQualifyIssuerDecision />;
};

export default NotQualify;
